import { useQuery } from '@apollo/client';
import { checkBadgeHidden } from '../../helpers/getBadge';
import { GET_BADGES } from '../../helpers/graphql/profile';
import Link from '@mui/material/Link';
import HeaderCard from '../General/HeaderCard';
import Badge from './Badge';

export default function BadgeCard({ user }) {
  const { data } = useQuery(GET_BADGES, {
    variables: { user },
  });

  if (!data || !data.getBadges || data.getBadges.length === 0) return <></>;
  return (
    <>
      <HeaderCard
        noborder
        title="Badges"
        titlesize="h6"
        bgCard
        content={
          <div className="pl-2 pr-2 pb-2 text-center">
            {data.getBadges.map(badge => {
              const isHidden = checkBadgeHidden(
                badge.type,
                badge.name,
                data.getBadges,
              );
              if (isHidden) return <></>;
              return (
                <Link
                  key={`/@${user}/badges/${badge.type}/${badge.name}`}
                  href={`/@${user}/badges/${badge.type}/${badge.name}`}
                >
                  <Badge {...badge} />
                </Link>
              );
            })}
          </div>
        }
      />
    </>
  );
}
